module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('dropzone', {
    ref: "dropzone",
    attrs: {
      "url": _vm.url,
      "maxNumberOfFiles": 10,
      "value": _vm.value
    },
    on: {
      "input": function (v) { return _vm.$emit('input', v); },
      "success": _vm.addedImage,
      "removed": _vm.removedImage,
      "clicked": _vm.useImage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17d78fd6","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/ImageUpload.vue
// module id = +Tcm
// module chunks = 0 1